import ComeBack from './ComeBack';

export default function TransferHeader({
  headerTitle,
  description = '',
  goBack,
}) {
  return (
    <div className="space-y-2">
      <ComeBack text={headerTitle} onClick={goBack} />
      <p className="text-sm text-[#535862] font-normal leading-[20px]">
        {description}
      </p>
    </div>
  );
}
